<template>
  <v-menu
    v-model="datePickerMenu"
    :disabled="disabled"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
          <v-text-field
          outlined
          :rules="rules"
          :disabled="disabled"
          v-model="parsedDate"
          :label="label"
          readonly
          v-bind="attrs"
          v-on="on"
          ></v-text-field>
      </template>
      <div>{{value}}</div>
      <v-date-picker
        v-model="date"
        locale="es-MX"
        type="month"
        @input="parseInput"
      ></v-date-picker>
  </v-menu>
</template>

<script>
import ENV from '../../../env.js'

export default {
  mounted() {
    this.parseInput(this.value)
    this.parseInput(this.default?.substring(0,7) || null)
  },
  methods: {
    parseInput (input) {
      this.date = input
      this.datePickerMenu = false
      if (!this.date) return null
      const date = this.date.substring(0,7)
      const [year,month] = date.split('-')
      this.parsedDate = `${ENV.months[parseInt(month)].abv.toUpperCase()}/${year}`
      this.$emit('input', this.date + '-01')
    }
  },
  watch: {
      value(value) {
        if (value) {
          this.date = value.substring(0,7);
          this.parseInput(this.date)
        }
      }
  },
  props: ['value', 'label', 'disabled', 'rules', 'default'],
  data() {
    return {
        datePickerMenu: false,
        date: null,
        parsedDate: null,
    }
  }
}
</script>

<style>

</style>
